export default __webpack_public_path__ + "src/apps/Map/components/MapLegend/assets/dividers.png";